// Bind jQuery's $ for this file. On /pages/partnertraining the full-source Jotform embed loads
// Prototype.js, which replaces the global $, and without this every jQuery call below fails there.
(function ($) {
  // header sticky
  const headerSection = document.getElementById("shopify-section-header");

  if (headerSection) {
    let measurementTimeout;

    const updateHeaderBottom = () => {
      const headerBottom = `${headerSection.getBoundingClientRect().bottom}px`;
      if (
        document.documentElement.style.getPropertyValue(
          "--header-bottom-position",
        ) === headerBottom
      ) {
        return;
      }

      document.documentElement.style.setProperty(
        "--header-bottom-position",
        headerBottom,
      );
    };

    const scheduleHeaderMeasurement = () => {
      clearTimeout(measurementTimeout);
      measurementTimeout = setTimeout(updateHeaderBottom, 100);
    };

    const stickySentinel = document.createElement("span");
    stickySentinel.setAttribute("data-header-sentinel", "");
    stickySentinel.setAttribute("aria-hidden", "true");
    headerSection.before(stickySentinel);

    new IntersectionObserver(([entry]) => {
      headerSection.toggleAttribute(
        "data-sticky",
        entry.boundingClientRect.bottom <= 0,
      );
    }).observe(stickySentinel);

    updateHeaderBottom();
    new ResizeObserver(scheduleHeaderMeasurement).observe(headerSection);
    window.addEventListener("resize", scheduleHeaderMeasurement);
    window.addEventListener("scroll", scheduleHeaderMeasurement, {
      passive: true,
    });
    headerSection.addEventListener("animationend", (event) => {
      if (event.target === headerSection) scheduleHeaderMeasurement();
    });
  }

  $(document).ready(function () {
    // Announcement  slider
    swiper = new Swiper(".announcement-bar-slider", {
      slidesPerView: 1,
      loop: true,
      speed: 1000,
      grabCursor: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      keyboard: {
        enabled: true,
      },
      navigation: {
        nextEl: ".headswipe-next",
        prevEl: ".headswipe-prev",
      },
      breakpoints: {
        1024: {
          slidesPerView: 1,
          loop: true,
        },
        414: {
          slidesPerView: 1,
          loop: true,
        },
        320: {
          slidesPerView: 1,
          loop: true,
        },
      },
    });

    // homepage slider — initialized in banner-slider.liquid section script

    // for second section's mobile slider
    // var swiper = new Swiper(".full-banner-slider", {
    //   effect: "cards",
    //   grabCursor: true,
    //   width: window.innerWidth - 0,
    //   centeredSlides: true,
    //   loop: true,
    //   cardsEffect: {
    //     rotate: false,
    //     //perSlideRotate: 'auto',
    //     perSlideRotate: 4,
    //     perSlideOffset: 7,
    //     slideShadows: true,
    //   },
    //   allowTouchMove: true,
    //   preventClicks: true,
    //   initialSlide: 0,
    //   roundLengths: true,
    //   // mousewheel: true,

    //   breakpoints: {
    //     768: {
    //       width: window.innerWidth - 100,
    //       perSlideOffset: 10,
    //     },
    //     575: {
    //       width: window.innerWidth - 70,
    //       perSlideOffset: 10,
    //     },
    //     414: {
    //       width: window.innerWidth - 50,
    //       perSlideOffset: 10,
    //     },
    //     320: {
    //       width: window.innerWidth - 45,
    //       perSlideOffset: 10,
    //     },
    //   },
    // });
    //swiper.setTransition(this, 0.5);
    //swiper.reInit();

    // sales portal page
    var swiper = new Swiper(".sales-blog-slider", {
      slidesPerView: 4,
      loop: true,
      grabCursor: true,
      //centeredSlides: true,
      spaceBetween: 40,
      slideToClickedSlide: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        dynamicBullets: true,
        //dynamicMainBullets: 10,
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + "</span>";
        },
      },
      breakpoints: {
        1280: {
          slidesPerView: 4.1,
          spaceBetween: 40,
        },
        1024: {
          slidesPerView: 2.3,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2.1,
          spaceBetween: 20,
        },
        575: {
          slidesPerView: 2.2,
          spaceBetween: 20,
        },
        414: {
          slidesPerView: 1.2,
          spaceBetween: 20,
        },
        320: {
          slidesPerView: 1.2,
          spaceBetween: 20,
        },
      },
    });

    // Sales blog slider slick slider
    class Pagination {
      constructor(dotsSelector) {
        this.dotsSelector = dotsSelector;

        this.maxLinks = 5;
        this.maxOffset = Math.ceil(this.maxLinks / 2);

        document.querySelector(this.dotsSelector).innerHTML = "";
      }

      generate(currentSlide, countSlides) {
        this.currentSlide = currentSlide + 1;
        this.countSlides = countSlides;

        this.offset_left = this.currentSlide > this.maxOffset;
        this.offset_right =
          this.currentSlide <= this.countSlides - this.maxOffset;

        if (this.countSlides > this.maxLinks) {
          if (this.currentSlide <= Math.floor(this.countSlides / 2)) {
            this.generateLeftPosition();
          } else if (this.currentSlide > Math.floor(this.countSlides / 2)) {
            this.generateRightPosition();
          }
        } else {
          this.generateDefault();
        }
      }

      generateDot(i, text, className = false, current = false) {
        var dot = document.createElement("li");

        if (className) {
          dot.classList.add(className);
        }

        if (i != "" && this.currentSlide == i) {
          dot.classList.add("active");
        }

        dot.id = i - 1;
        dot.innerText = text;

        document.querySelector(this.dotsSelector).appendChild(dot);
      }

      generateLeftPosition() {
        if (this.currentSlide != 1) {
          for (
            var i = this.currentSlide - 1;
            i < this.currentSlide - 1 + this.maxOffset;
            i++
          ) {
            this.generateDot(i, i, "dot");
          }
          this.generateDot("", "...");
          this.generateDot(this.countSlides, this.countSlides, "dot");
        } else {
          for (
            var i = this.currentSlide;
            i < this.currentSlide + this.maxOffset;
            i++
          ) {
            this.generateDot(i, i, "dot");
          }
          this.generateDot("", "...");
          this.generateDot(this.countSlides, this.countSlides, "dot");
        }
      }

      generateRightPosition() {
        if (this.currentSlide != this.countSlides) {
          this.generateDot(1, 1, "dot");
          this.generateDot("", "...");
          for (
            var i = this.currentSlide - 1;
            i < this.currentSlide - 1 + this.maxOffset;
            i++
          ) {
            this.generateDot(i, i, "dot");
          }
        } else {
          this.generateDot(1, 1, "dot");
          this.generateDot("", "...");
          for (
            var i = this.countSlides + 1 - this.maxOffset;
            i <= this.countSlides;
            i++
          ) {
            this.generateDot(i, i, "dot");
          }
        }
      }

      generateDefault() {
        for (var i = 1; i < this.countSlides + 1; i++) {
          this.generateDot(i, i, "dot");
        }
      }
    }

    $(document).ready(function () {
      if ($("#g2-slider").length) {
        var g2Slider = $("#g2-slider");

        function addSliderListeners() {
          var dots = document.querySelectorAll(".dot");
          dots.forEach(function (el) {
            el.addEventListener("click", function () {
              g2Slider.slick("slickGoTo", el.id);
            });
          });
        }

        g2Slider.on("init", function (event, slick) {
          var pag = new Pagination("#g2-slider-pagination-list");
          pag.generate(slick.currentSlide, slick.slideCount);
          addSliderListeners();
        });

        g2Slider.on(
          "beforeChange",
          function (event, slick, currentSlide, nextSlide) {
            var pag = new Pagination("#g2-slider-pagination-list");
            pag.generate(nextSlide, slick.slideCount);

            addSliderListeners();
          },
        );

        /* slider initialization */
        g2Slider.slick({
          infinite: true,
          slidesToShow: 4,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: "100px",
          focusOnSelect: true,
          adaptiveHeight: true,
          draggable: true,
          speed: 500,
          cssEase: "linear",
          prevArrow: $(".g2-slider-pagination .prev"),
          nextArrow: $(".g2-slider-pagination .next"),
          responsive: [
            {
              breakpoint: 1280,
              settings: {
                centerMode: true,
                centerPadding: "40px",
                slidesToShow: 3,
              },
            },
            {
              breakpoint: 1024,
              settings: {
                centerMode: true,
                centerPadding: "40px",
                slidesToShow: 2,
              },
            },
            {
              breakpoint: 480,
              settings: {
                centerMode: true,
                centerPadding: "40px",
                slidesToShow: 1,
              },
            },
            {
              breakpoint: 320,
              settings: {
                centerMode: true,
                centerPadding: "20px",
                slidesToShow: 1,
              },
            },
          ],
        });
      }
    });

    // homepage blog slider
    var swiper = new Swiper(".blog-slider", {
      slidesPerView: 5,
      loop: false,
      centeredSlides: false,
      spaceBetween: 20,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        1440: {
          slidesPerView: 5,
          loop: false,
        },
        1024: {
          slidesPerView: 3,
          loop: false,
        },
        768: {
          slidesPerView: 2.5,
          loop: true,
        },
        575: {
          slidesPerView: 2.5,
          loop: true,
        },
        414: {
          slidesPerView: 1.2,
          loop: true,
        },
        320: {
          slidesPerView: 1.2,
          loop: true,
        },
      },
    });
  });

  // faq
  $(document).ready(function () {
    $(".accodion-heading").on("click", function () {
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(this).siblings(".accodion-content").slideUp(200);
      } else {
        $(this);
        $(".accodion-heading").removeClass("active");
        $(this).addClass("active");
        $(".accodion-content").slideUp(200);
        $(this).siblings(".accodion-content").slideDown(200);
      }
    });
  });

  // Open Popup

  $(".login_popup").click(function (e) {
    e.preventDefault();
    $(".customer-account").removeClass("hidden");
    $(".ctm-login-modal-bg").addClass("active");
    $(".customer-account").addClass("login-left");
    $(".login_popup.header__icon").addClass("active");
    $("body").addClass("login-popu-active");
  });

  $(".ctm-login-modal-bg").click(function () {
    $(this).removeClass("active");
    $(".customer-account").addClass("hidden");
    $(".customer-account").removeClass("login-left");
    $(".login_popup.header__icon").removeClass("active");
    $("body").removeClass("modal-overflow");
    $("body").removeClass("modal-overlay-active");
    $("body").removeClass("login-popu-active");
  });

  $(".tab-heading ul li a").click(function () {
    var tab_idd = $(this).attr("data-tab");

    $(".tab-heading ul li a").removeClass("current");
    $(".account-tab.tab-pane").removeClass("current");

    $(this).addClass("current");
    $("#" + tab_idd).addClass("current");
  });

  /** Tuxton Megamenu **/
  /** Megamenu start **/

  $(".header__inline-menu a").hover(function () {
    var data = $(this).data("dropdown-rel");
    $(".mega-menu")
      .parent(".mega-menu-section")
      .addClass("opacity-0 h-0 invisible");
    $("body").addClass("overflow-hidden");
    $('.mega-menu[data-dropdown="' + data + '"]')
      .parent(".mega-menu-section")
      .removeClass("opacity-0 h-0 invisible");
  });

  $(".header__inline-menu")
    .mouseleave(function () {
      if ($(".mega-menu-section:hover").length == 0) {
        $(".mega-menu")
          .parent(".mega-menu-section")
          .addClass("opacity-0 h-0 invisible");
        $("body").removeClass("overflow-hidden");
      }
    })
    .mouseleave();

  $(".mega-menu-section")
    .mouseleave(function () {
      $(this).addClass("opacity-0 h-0 invisible");
      $("body").removeClass("overflow-hidden");
    })
    .mouseleave();

  $(".header-dropdown").mouseenter(function () {
    $(".mega-menu")
      .parent(".mega-menu-section")
      .addClass("opacity-0 h-0 invisible");
  });

  // $(document).ready(function(){
  //   $(".header__inline-menu a").hover(
  //       function() {
  //         //var data = $(this).data('dropdown-rel');
  //           let mm = $(this).attr("data-mega-menu");
  //           $(`.mega-menu-section.${mm}`).stop( true, true ).slideDown(1000);
  //           //$('.mega-menu[data-dropdown="' + data + '"]').parent('.mega-menu-section').toggleClass('open');
  //           $(this).toggleClass('open');
  //       },
  //       function() {
  //           let mm = $(this).attr("data-mega-menu");
  //           $(`.mega-menu-section.${mm}`).stop( true, true ).slideUp(200);
  //           $(this).toggleClass('open');
  //       }
  //   );
  // });

  $(document)
    .on("mouseenter", ".header__inline-menu ul li a", function (event) {
      if ($(".mega-menu-section").hasClass("hiddens")) {
      } else {
        $(".dropdown_content .dropdown_column")
          .not(this)
          .removeClass("first_active");
        $(".dropdown_content .dropdown_column.dropdown1").addClass(
          "first_active",
        );

        $(".menu_img_wrapper").not(this).removeClass("firstimage_active");
        $(".menu_img_wrapper.menu_img_wrapper1").addClass("firstimage_active");
      }
    })
    .on("mouseleave", ".header__inline-menu ul li a", function () {
      if ($(".mega-menu-section").hasClass("hiddens")) {
      } else {
        $(".dropdown_content .dropdown_column").removeClass("first_active");
        ".menu_img_wrapper".removeClass("firstimage_active");
      }
    });

  //mega menu active class on hover
  // active product menu

  // on hover
  $(".mega-menu2 .dropdown_content .dropdown_column").hover(
    function () {
      $(this).addClass("ctm-Classactive");
    },
    function () {
      $(this).removeClass("ctm-Classactive");
    },
  );

  $(".mega-menu2 .dropdown_content .dropdown_column").hover(function () {
    console.log($(this).attr("data-submenu-index"));
    $(".menu_img_wrapper").removeClass("ctm-menu_img_wrapper");
    $(
      ".menu_img_wrapper[data-index='" +
        $(this).attr("data-submenu-index") +
        "']",
    ).addClass("ctm-menu_img_wrapper");
  });

  $("#myDropdown li a").hover(
    function () {
      var imageSrc = $(this).data("img");
      $(".ctm-menu_img_wrapper img").attr("src", imageSrc);
    },
    function () {
      var collectionDefault = $(".ctm-menu_img_wrapper img").data(
        "collection-img",
      );
      $(".ctm-menu_img_wrapper img").attr("src", collectionDefault);
    },
  );

  // MEGA MENU ACTIVE LINK
  $(document).ready(function () {
    $(".mega-menu [href]").each(function () {
      if (this.href == window.location.href) {
        // console.log(this.href);
        $(".dropdown_column").removeClass("product_menu_active");
        $(this)
          .closest(".mega-menu__image-caption-link")
          .parents(".dropdown_column")
          .addClass("product_menu_active");
      }
    });
    $(".ctm_click_megamenu [href]").each(function () {
      // console.log(this.href);
      if (this.href == window.location.href) {
        //  console.log(this.href);
        $(".dropdown_column").removeClass("product_menu_active_mob");
        $(this)
          .closest(".mega-menu__image-caption-link")
          .parents(".dropdown_column")
          .addClass("product_menu_active_mob");
        if ($(".dropdown_column").hasClass("product_menu_active_mob")) {
          $(this).closest("li").addClass("pdp_active");
          $(".product_menu_active_mob")
            .parentsUntil(".ctm_click_megamenu")
            .parent("li")
            .addClass("pdp_active");
        }
      }
    });
  });

  setTimeout(function () {
    var check_class = $(
      ".dropdown_container.mega-menu .dropdown_content .product_menu_active",
    ).length;

    if (check_class == 1) {
      var menu_nm = $(".dropdown_container.mega-menu").data("dropdown");
      $(".headermenu_list li").each(function () {
        var drop_rel = $(this).find("a").data("dropdown-rel");
        if (menu_nm == drop_rel) {
          $(this).find("span").addClass("header__active-menu-item");
        }
      });
    } else {
    }
  }, 1000);

  /** Megamenu end **/

  // Mobile menu

  // mobile sub-menu hide show
  $(".menu-drawer__menu .ctm_click").on("click", function () {
    if ($(this).children(".drop-box-ctm").hasClass("submenu-open-ctm")) {
      $(this).children(".drop-box-ctm").removeClass("submenu-open-ctm");
      setTimeout(function () {
        $(this).children(".drop-box-ctm").removeAttr("open");
      }, 1000);
    } else {
      $(".menu-drawer__menu .ctm_click .drop-box-ctm").removeClass(
        "submenu-open-ctm",
      );
      $(".menu-drawer__menu .ctm_click .drop-box-ctm").removeAttr("open");
      $(this).children(".drop-box-ctm").addClass("submenu-open-ctm");
      $(this).children(".drop-box-ctm").attr("open");
    }
  });

  // mobile megamenu start
  $(".menu-drawer__menu li").each(function () {
    var MainThis = $(this);
    var MobMegaMenuRel = $(this).data("dropdown-rel-mob");
    if ($('.mega-menu[data-dropdown="' + MobMegaMenuRel + '"]').length) {
      var MobileMenuHtml = $(
        '.mega-menu[data-dropdown="' + MobMegaMenuRel + '"]',
      ).html();
      MainThis.append(
        '<span class="drawer-menu-arrow mob_drop_arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-down" width="15" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.75742 8.96753L0.307861 2.51777C-0.102621 2.10748 -0.102621 1.44228 0.307861 1.0322C0.717978 0.62208 1.38315 0.62208 1.79323 1.0322L7.50011 6.73924L13.2068 1.03236C13.6171 0.622246 14.2822 0.622246 14.6923 1.03236C15.1026 1.44248 15.1026 2.10765 14.6923 2.51793L8.24263 8.96769C8.03747 9.17275 7.76887 9.27516 7.50014 9.27516C7.23128 9.27516 6.96248 9.17255 6.75742 8.96753Z" fill="currentColor"></path></svg></span>' +
          MobileMenuHtml,
      );
    }
  });

  $(".dropdown_container.mega-menu a").each(function () {
    if ($(this).hasClass("active")) {
      var parentMenu = $(this)
        .closest(".dropdown_container.mega-menu")
        .attr("data-dropdown");
      $('[data-dropdown-rel="' + parentMenu + '"]').addClass("active");
    }
  });

  $(".dropdown_content .dropdown_column a").each(function () {
    if ($(this).hasClass("active")) {
      $(this).closest("li[data-dropdown-rel-mob]").addClass("active");
    }
  });

  $(document).on("click", ".drawer-menu-arrow", function () {
    $(".menu-drawer__menu .ctm_click .drop-box-ctm").removeClass(
      "submenu-open-ctm",
    );
    $(".menu-drawer__menu .ctm_click .drop-box-ctm").removeAttr("open");
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      console.log("if");
      $(this).parent("li").removeClass("text-cobaltBlue");
      $(this).closest("li").children(".dropdown.menu").removeClass("open");
    } else {
      console.log("else");
      $(".drawer-menu-arrow").removeClass("active");
      $(".menu-drawer__menu li .dropdown.menu").removeClass("open");
      $(".menu-drawer__menu li").removeClass("text-cobaltBlue");
      $(this).addClass("active");
      $(this).parent("li").addClass("text-cobaltBlue");
      $(this).closest("li").children(".dropdown.menu").addClass("open");
    }
  });

  $(document).on("click", ".drawer-menu-arrow-m", function () {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      //console.log('true');
      //$(this).closest('li').children('.dropdown.menu').removeClass('open');
    } else {
      //console.log('else');
      $(".drawer-menu-arrow-m").removeClass("active");
      //$('.menu-drawer__menu li .dropdown.menu').removeClass('open');
      $(this).addClass("active");
      //$(this).closest('li').children('.dropdown.menu').addClass('open');
    }
  });

  // News event filter

  $(function () {
    $("#BlogTagFilter").on("change", function () {
      var url = $(this).val(); // get selected value
      if (url) {
        // require a URL
        window.location = url; // redirect
      }
      return false;
    });

    $("#FilterTags").on("change", function () {
      var url = $(this).val(); // get selected value
      if (url) {
        // require a URL
        window.location.href = url; // redirect
      }
      return false;
    });
  });
  $(function () {
    $(".blog-list").slice(0, 3).show();
    $("body").on("click touchstart", ".load-more", function (e) {
      e.preventDefault();
      $(".blog-list:hidden").slice(0, 3).slideDown();
      if ($(".blog-list:hidden").length == 0) {
        $(".load-more").css("visibility", "hidden");
      }
      // $('html,body').animate({
      //   scrollTop: $(this).offset().top
      // }, 1000);
    });
  });

  // js for reset passwords and forgot passwords

  $(document).ready(function () {
    $(".drawer_reset_btn").click(function () {
      $(".drawer_reset_area").toggleClass("hidden");
      $(".reset-below-btn").addClass("hidden");
    });
  });

  $(document).ready(function () {
    $(".reset-cancel").click(function () {
      $(".reset-below-btn").removeClass("hidden");
      $(".drawer_reset_area").addClass("hidden");
    });
  });

  $(document).ready(function () {
    $(".forgot-pass-btn").click(function () {
      $(".forgot_pass_block").removeClass("hidden");
      $(".forgot-block-area").addClass("hidden");
    });
  });

  $(document).ready(function () {
    $(".forgot_reset-cancel").click(function () {
      $(".forgot_pass_block").addClass("hidden");
      $(".forgot-block-area").removeClass("hidden");
    });
  });

  // js for cart page button ( quick quote )
  $(".quote-info").attr("style", "");

  $("#quick-quote-wrapper")
    .contents()
    .filter(function () {
      return this.nodeType != 1;
    })
    .remove();

  // for scroll top on swatch click
  $(document).ready(function () {
    // Bind click event to swatch elements
    $(".switch-list label").click(function () {
      // Scroll to the top of the page
      $("html, body").animate({ scrollTop: 0 }, "slow");
    });
  });

  // Header searchBar
  $(document).ready(function () {
    $(".header__search .icon-search").click(function (e) {
      $("body").addClass("model_search_bar");
    });
  });

  // 404 redirects
  var patterns = [
    "?coll_id=26&page=collection",
    "?cat_id=2&page=category",
    "?coll_id=12&page=collection",
    "?coll_id=61&page=collection",
    "?cat_id=5&page=category",
    "?cat_id=4&page=category",
    "?coll_id=5&page=collection",
    "?coll_id=13&page=collection",
    "?coll_id=60&page=collection",
    "?coll_id=6&page=collection",
    "?coll_id=66&page=collection",
    "?coll_id=9&page=collection",
    "?coll_id=72&page=collection",
    "?coll_id=14&page=collection",
    "?cat_id=1&page=category",
    "?coll_id=11&page=collection",
    "?coll_id=2&page=collection",
    "?coll_id=67&page=collection",
    "?coll_id=18&page=collection",
    "?coll_id=20&page=collection",
    "?cat_id=6&page=category",
    "?coll_id=15&page=collection",
    "?coll_id=3&page=collection",
    "?coll_id=64&page=collection",
    "?coll_id=8&page=collection",
    "?coll_id=63&page=collection",
    "?coll_id=1&page=collection",
    "?coll_id=70&page=collection",
    "?coll_id=35&page=collection",
    "?coll_id=16&page=collection",
    "?coll_id=4&page=collection",
    "?coll_id=65&page=collection",
    "?coll_id=17&page=collection",
    "?coll_id=7&page=collection",
    "?coll_id=57&page=collection",
    "?coll_id=24&page=collection",
    "?coll_id=56&page=collection",
    "?coll_id=54&page=collection",
    "?coll_id=33&page=collection",
    "?coll_id=10&page=collection",
    "?coll_id=62&page=collection",
    "?coll_id=55&page=collection",
    "?coll_id=59&page=collection",
    "?coll_id=19&page=collection",
    "?coll_id=34&page=collection",
    "https://tuxton.com/?cat_id=2&page=category",
    "?page=category",
  ];
  var currentUrl = window.location.href;

  for (var i = 0; i < patterns.length; i++) {
    if (currentUrl.includes(patterns[i])) {
      window.location.href = "/";
      break;
    }
  }

  // to the collections

  if (
    currentUrl === "http://www.tuxton.com/?coll_id=23&page=collection" ||
    currentUrl === "https://www.tuxton.com/?coll_id=23&page=collection"
  ) {
    window.location.href = "/collections";
  }

  // mansory grid clickable image start

  // Create popup overlay element
  const popupOverlay = document.createElement("div");
  popupOverlay.id = "image-popup-overlay";
  popupOverlay.style.cssText = `
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: none;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

  const popupImage = document.createElement("img");
  popupImage.id = "popup-image";
  popupImage.alt = "";
  popupImage.setAttribute("role", "presentation");
  popupImage.style.cssText = `
  max-width: 90%;
  max-height: 90%;
  border-radius: 10px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.5);
`;
  popupOverlay.appendChild(popupImage);

  // Close button
  const closeButton = document.createElement("span");
  closeButton.id = "close-button";
  closeButton.innerHTML = "&times;";
  closeButton.style.cssText = `
  position: absolute;
  top: 20px;
  right: 30px;
  font-size: 3rem;
  color: white;
  cursor: pointer;
  z-index: 10000;
`;
  popupOverlay.appendChild(closeButton);

  document.body.appendChild(popupOverlay);

  // Navigation arrows
  const leftArrow = document.createElement("span");
  leftArrow.id = "left-arrow";
  leftArrow.innerHTML = "&#10094;";
  leftArrow.style.cssText = `
  position: absolute;
  top: 50%;
  left: 30px;
  font-size: 3rem;
  color: white;
  cursor: pointer;
  transform: translateY(-50%);
  z-index: 10000;
`;
  popupOverlay.appendChild(leftArrow);

  const rightArrow = document.createElement("span");
  rightArrow.id = "right-arrow";
  rightArrow.innerHTML = "&#10095;";
  rightArrow.style.cssText = `
  position: absolute;
  top: 50%;
  right: 30px;
  font-size: 3rem;
  color: white;
  cursor: pointer;
  transform: translateY(-50%);
  z-index: 10000;
`;
  popupOverlay.appendChild(rightArrow);

  const images = Array.from(document.querySelectorAll(".project-install img"));
  let currentIndex = 0;

  function showImage(index) {
    currentIndex = (index + images.length) % images.length;
    popupImage.src = images[currentIndex].src;
    popupImage.alt = images[currentIndex].alt || "Enlarged image";
    popupOverlay.style.display = "flex";
  }

  images.forEach((img, index) => {
    img.addEventListener("click", () => showImage(index));
  });

  leftArrow.addEventListener("click", (e) => {
    e.stopPropagation();
    showImage(currentIndex - 1);
  });

  rightArrow.addEventListener("click", (e) => {
    e.stopPropagation();
    showImage(currentIndex + 1);
  });

  closeButton.addEventListener("click", (e) => {
    e.stopPropagation();
    popupOverlay.style.display = "none";
  });

  popupOverlay.addEventListener("click", () => {
    popupOverlay.style.display = "none";
  });

  // mansory grid clickable image End

  // Smooth scroll for #jotform-studiotux anchor links on studiotux page
  document.addEventListener("click", function (e) {
    var link = e.target.closest("a[href]");
    if (!link) return;
    var href = link.getAttribute("href");
    var targetId = "jotform-studiotux";
    var isAnchorOnly = href === "#" + targetId;
    var isSamePageFull =
      href.includes("/" + targetId) === false &&
      (href === window.location.pathname + "#" + targetId ||
        href === window.location.href.split("#")[0] + "#" + targetId ||
        href.match(/\/pages\/studiotux\/?#jotform-studiotux$/));
    if (isAnchorOnly || isSamePageFull) {
      var target = document.getElementById(targetId);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  });
})(jQuery);
